/**
 * Consolidated Performance table: highlight cells when the API reports an explicit null.
 * Zero and undefined are not highlighted.
 * @param {*} value — cell value from branch consolidated data
 * @returns {boolean}
 */
export function isConsolidatedPerformanceExplicitNull(value) {
  return value === null;
}
